<main>
        <div class="contenedor">
            <!-- Header del proyecto -->
            <section class="header-proyecto">
                <div class="imagen-proyecto"></div>
                <div class="titulo-con-flecha">
                    <a routerLink="/portafolio" class="btn-regreso">
                        <img src="assets/svg/flecha.svg" alt="Regresar">
                    </a>
                    <h1 class="titulo-proyecto">Carretera Lima – Canta</h1>
                </div>
                <div class="cuadro_ubicacion">
                    <div class="ubicacion-proyecto">
                    <span class="icono-ubicacion"><img src="assets/svg/IconoMap.svg" alt=""></span>
                        Lima – Región Sierra Central
                    </div>
                </div>
                
            </section>

            <!-- Seccié³n de informacié³n del proyecto -->
            <section class="seccion-info-proyecto">
                <div class="grid-info">
                    <div class="info-columna">
                        <h3>Importancia</h3>
                        <p>Proyecto vial estratégico que constituye una ruta alterna a la Carretera Central, mejorando la conectividad entre Lima y la sierra central, reduciendo tiempos de viaje y descongestionando el principal corredor logístico del país.</p>
                    </div>
                    <div class="separador-vertical"></div>
                    <div class="info-columna">
                        <h3>Descripción del proyecto</h3>
                        <p>Construcción y mejoramiento integral de la vía Lima – Canta – Huayllay, incluyendo obras de movimiento de tierras, estructuras, sistemas de drenaje y habilitación de campamentos operativos.</p>
                    </div>
                </div>
            </section>

            <!-- Seccié³n de participacié³n -->
            <section class="seccion-participacion">
                <div class="contenido-participacion">
                    <div class="circulo-azul-decorativo"></div>
                    <div class="info-participacion">
                        <h2>Participación de Corporación Rehobot</h2>
                        <p>Se ejecutó la implementación integral del sistema de abastecimiento de agua y la electrificación del campamento principal, donde se desarrolló la puesta en marcha y el control operativo del proyecto.</p>
                    </div>
                    <div class="imagen-participacion"></div>
                </div>
            </section>

            <!-- Sección de actividades -->
            <section class="seccion-actividades">
                <h2 class="actividades-titulo">Actividades <span>desarrolladas.</span></h2>
                <div class="contenido-actividades">
                    <div class="tarjeta-actividad">
                    </div>
                    <div class="tarjeta-lista-actividades">
                        <ul class="lista-actividades">
                            <li><strong>Perforación y habilitación de un pozo tubular</strong> como fuente propia para el suministro de agua.</li>
                            <li><strong>Instalación del sistema de bombeo y línea de conducción</strong> para el llenado de los tanques reservorios del campamento.</li>
                            <li><strong>Diseño e implementación de redes eléctricas</strong> en media y baja tensión, asegurando energía confiable para la operación.</li>
                            <li><strong>Instalación de pozos a tierra</strong> en todo el campamento, cumpliendo estándares de seguridad eléctrica.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <!-- Sección Más proyectos -->
            <section class="seccion-mas-proyectos">
              <div class="divisor-linea"></div>
              <h2 class="mas-proyectos-titulo">Más <span>proyectos.</span></h2>

              <div class="grid-mas-proyectos">
                <div class="tarjeta-obra-mini" *ngFor="let obra of proyectosRecomendados">
                  <div class="imagen-obra-mini"
                       [style.backgroundImage]="'url(' + obra.imagen + ')'">
                  </div>
                  <div class="contenido-mini">
                    <h3>{{ obra.titulo }}</h3>
                    <a [routerLink]="obra.link" class="btn-conoce-mas">Conoce más</a>
                  </div>
                </div>
              </div>
            </section>
        </div>
    </main>